module.exports = __webpack_public_path__ + "assets/img/zy2.a7b3717c.png";